var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"wscn-http404-container"},[_c('img',{attrs:{"src":require("@/assets/images/404.svg"),"alt":"404"}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.tip))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }